import React, { useEffect, useState, createElement } from 'react';
import { ArrowRightIcon, TrendingUpIcon, SearchIcon, StarIcon, ShieldCheckIcon, LayoutIcon, CodeIcon, MousePointerClickIcon, LineChartIcon, BriefcaseIcon, CoffeeIcon, WrenchIcon, ShoppingBagIcon, HeartPulseIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function WebsiteLatenMakenPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Website laten maken | Professioneel webdesign | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Professionele website laten maken? Noord Digital bouwt conversiegerichte websites voor MKB en ZZP in Noord-Holland. Van strategie tot livegang, inclusief SEO.';
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Website laten maken | Professioneel webdesign | Noord',
      'og:description': 'Professionele website laten maken? Noord Digital bouwt conversiegerichte websites voor MKB en ZZP in Noord-Holland.',
      'og:type': 'website',
      'og:url': 'https://noorddigital.nl/website-laten-maken',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: 'Wat kost een website laten maken?',
    a: "De kosten voor een website variëren afhankelijk van je wensen, het aantal pagina's en de benodigde functionaliteiten. We bieden altijd een transparante prijsopgave vooraf, zodat je precies weet waar je aan toe bent zonder verborgen kosten."
  }, {
    q: 'Hoe lang duurt het om een website te maken?',
    a: 'Een standaard bedrijfswebsite is vaak binnen 2 tot 4 weken live. Voor complexere websites of maatwerk oplossingen plannen we samen een realistische tijdlijn in.'
  }, {
    q: 'Kan ik zelf de website aanpassen?',
    a: 'Ja, wij bouwen onze websites met gebruiksvriendelijke systemen (zoals WordPress). Je krijgt na oplevering uitleg zodat je zelf eenvoudig teksten en afbeeldingen kunt aanpassen.'
  }, {
    q: 'Is SEO inbegrepen?',
    a: 'Absoluut. Elke website die wij opleveren is technisch geoptimaliseerd voor zoekmachines. We zorgen voor de juiste structuur, snelle laadtijden en basis on-page SEO zodat je direct goed vindbaar bent.'
  }, {
    q: 'Wat gebeurt er na oplevering?',
    a: 'Na livegang laten we je niet in de steek. We bieden betrouwbare hosting en technisch onderhoud aan, zodat je website altijd snel, veilig en up-to-date blijft.'
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-2437" data-mp="25xhl7qe9lo15">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-2438" data-mp="25zudawdqlerx">
        <div className="absolute inset-0 pointer-events-none" data-id="element-2439" data-mp="1s7wa126pid3o">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-2440" data-mp="1x4mojl2v50mz" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-2441" data-mp="1i9ggksk7irr0" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-2442" data-mp="1n6gm92d59shl" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2443" data-mp="2gqrpbsdkm64o">
          {/* Breadcrumb */}
          <nav className="flex items-center justify-center gap-2 text-sm mb-8 animate-fade-in-up" data-id="element-2444" data-mp="2br5d9m9havxg">
            <a href="#/" className="text-navy-400 hover:text-white transition-colors" data-id="element-2445" data-mp="26s269w9xufmu">
              Home
            </a>
            <span className="text-navy-500" data-id="element-2446" data-mp="1xujfscdiz93k">/</span>
            <span className="text-accent-light font-medium" data-id="element-2447" data-mp="1xvbbdn74h6tu">
              Website laten maken
            </span>
          </nav>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-2448" data-mp="3s815o61eki1r">
            Website laten maken die klanten oplevert
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-2449" data-mp="3urxk0r8vw3d5">
            Professionele websites voor bedrijven die online willen groeien. Wij
            ontzorgen je volledig, van strategie tot livegang.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-2450" data-mp="8d4ozxkr7tdn">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-2451" data-mp="dbpfv6e490pf">
              Plan een gesprek
              <ArrowRightIcon className="w-5 h-5" data-id="element-2452" data-mp="3lpodsdknew5k" />
            </a>
          </div>
        </div>
      </section>

      {/* Waarom Section */}
      <section className="py-24 bg-surface-muted" data-id="element-2453" data-mp="1110iktf11567">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2454" data-mp="110ifbcty5qos">
          <div className="text-center mb-16" data-id="element-2455" data-mp="15zlj6ty6xqv6">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2456" data-mp="15ya9kdi2dow5">
              Waarom een goede website belangrijk is
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2457" data-mp="2x4ojd1dq11in">
              Een sterke online aanwezigheid is onmisbaar voor de groei van jouw
              bedrijf.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2458" data-mp="3722xguc69e7s">
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2459" data-mp="2jcic64sjq4vc">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2460" data-mp="2ee733wa2rye6">
                <TrendingUpIcon className="w-6 h-6 text-accent" data-id="element-2461" data-mp="2s5bw4fixtsfj" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2462" data-mp="2neloevn1hdho">
                Meer aanvragen
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2463" data-mp="1znzmlm3mopg4">
                Zet websitebezoekers om in betalende klanten met een
                conversiegerichte aanpak.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2464" data-mp="1li7lt0i7zbag">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2465" data-mp="1qaqzryktk8fs">
                <SearchIcon className="w-6 h-6 text-accent" data-id="element-2466" data-mp="1bmmfwra15qvf" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2467" data-mp="1gl7fqplde8jc">
                Betere vindbaarheid
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2468" data-mp="24aa0457e2fhj">
                Word lokaal en regionaal beter gevonden in Google door
                potentiële klanten.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2469" data-mp="1ubay35h4pi3i">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2470" data-mp="1zcqj4xjb3olw">
                <StarIcon className="w-6 h-6 text-accent" data-id="element-2471" data-mp="iyqmbvfrcf2v" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2472" data-mp="nws4me5d0ada">
                Professionele uitstraling
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2473" data-mp="5uvn96z4uxi">
                Maak een onuitwisbare eerste indruk met een modern en strak
                webdesign.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2474" data-mp="3nakhvefw37c0">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2475" data-mp="nvfp4m0r7al1">
                <ShieldCheckIcon className="w-6 h-6 text-accent" data-id="element-2476" data-mp="iwmf53koe1pm" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2477" data-mp="e5mfhqk695jf">
                Meer vertrouwen
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2478" data-mp="a4kh1by2wxii">
                Straal autoriteit uit en overtuig bezoekers van jouw expertise
                en kwaliteit.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Wat wij bouwen */}
      <section className="py-24 bg-white" data-id="element-2479" data-mp="2khyiu2r089ah">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2480" data-mp="2kj02uwq0064c">
          <div className="text-center mb-16" data-id="element-2481" data-mp="2pgrvjsygvw9l">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2482" data-mp="2phl6750jr5x0">
              Wat wij bouwen
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2483" data-mp="2tkr7rzcps8x5">
              Oplossingen op maat voor jouw specifieke bedrijfsdoelen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2484" data-mp="33gb3olra37lw">
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2485" data-mp="38f471lcupi8c">
              <div className="flex items-start gap-4" data-id="element-2486" data-mp="3d7oxqe0gnf7n">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-2487" data-mp="3h87t2i1kb3el">
                  <LayoutIcon className="w-6 h-6 text-navy-700" data-id="element-2488" data-mp="3m7kfx2sfoah6" />
                </div>
                <div data-id="element-2489" data-mp="3r6evlvv3tix2">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-2490" data-mp="3r5vozbawmgyc">
                    Bedrijfswebsite
                  </h3>
                  <p className="text-slate-600" data-id="element-2491" data-mp="2euszuhte0m6i">
                    Een compleet online visitekaartje dat jouw diensten,
                    projecten en bedrijfscultuur perfect presenteert.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2492" data-mp="2sl652cew9ms5">
              <div className="flex items-start gap-4" data-id="element-2493" data-mp="2xixwz6fjh8wc">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-2494" data-mp="32j3rcud719i4">
                  <CodeIcon className="w-6 h-6 text-navy-700" data-id="element-2495" data-mp="37igfrjjpqomt" />
                </div>
                <div data-id="element-2496" data-mp="3bjs5rq6i1bvj">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-2497" data-mp="3bkaazcb530fl">
                    WordPress website
                  </h3>
                  <p className="text-slate-600" data-id="element-2498" data-mp="1d5qj4u1yn1bq">
                    Flexibele, makkelijk te beheren websites gebouwd op het
                    meest populaire CMS ter wereld.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2499" data-mp="14vrtc25r6tda">
              <div className="flex items-start gap-4" data-id="element-2500" data-mp="zvnc29x0tum0">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-2501" data-mp="zucamgr1syy2">
                  <MousePointerClickIcon className="w-6 h-6 text-navy-700" data-id="element-2502" data-mp="1sl406vdlypcf" />
                </div>
                <div data-id="element-2503" data-mp="1nlztcbe5p3p9">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-2504" data-mp="1nlhpotp5zn7b">
                    Landingspagina's
                  </h3>
                  <p className="text-slate-600" data-id="element-2505" data-mp="1jj380cx8ethm">
                    Doelgerichte pagina's speciaal ontworpen voor
                    advertentiecampagnes en maximale leadgeneratie.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2506" data-mp="35mr6lzrvy9z">
              <div className="flex items-start gap-4" data-id="element-2507" data-mp="4n1xdrwb67zx">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-2508" data-mp="4liedtj9piug">
                  <LineChartIcon className="w-6 h-6 text-navy-700" data-id="element-2509" data-mp="3rs18tiig2nj2" />
                </div>
                <div data-id="element-2510" data-mp="3rudm3id9c9ps">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-2511" data-mp="3vt3as73qxdoq">
                    Conversie geoptimaliseerde websites
                  </h3>
                  <p className="text-slate-600" data-id="element-2512" data-mp="3i0wtuisrr2o8">
                    Websites waarbij elke knop, tekst en afbeelding is ingericht
                    om de bezoeker tot actie te laten overgaan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proces */}
      <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-2513" data-mp="2z3lxb5yiunch">
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-2514" data-mp="2z5ghuj5vsdg1" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2515" data-mp="2filqb01g6br1">
          <div className="text-center mb-16" data-id="element-2516" data-mp="2th35uah78hxv">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-2517" data-mp="2tiwfzzr0tkam">
              Ons proces
            </h2>
            <p className="text-lg text-navy-300 max-w-2xl mx-auto" data-id="element-2518" data-mp="2phugdht6z684">
              In 5 heldere stappen naar jouw nieuwe website.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-id="element-2519" data-mp="2yfefak3l0qfk">
            {['Kennismaking', 'Strategie', 'Ontwerp', 'Ontwikkeling', 'Livegang'].map((step, i) => <div key={step} className="bg-white/[0.06] border border-white/10 p-6 rounded-2xl text-center relative" data-id="element-2520" data-mp="3m60fxqb9b8fj" data-mpi={i}>
                <span className="absolute top-2 right-4 text-4xl font-bold text-white/[0.05]" data-id="element-2521" data-mp="3h8qtmjj5zcvx">
                  {i + 1}
                </span>
                <div className="w-10 h-10 rounded-full bg-accent/20 text-accent flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-2522" data-mp="1kgl4w51i1fnb">
                  {i + 1}
                </div>
                <h3 className="text-white font-bold" data-id="element-2523" data-mp="1t95539xfvsa9">{step}</h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* Voor wie */}
      <section className="py-24 bg-surface-muted" data-id="element-2524" data-mp="wkgtowg8b39t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2525" data-mp="11hgvuw9yjlvn">
          <div className="text-center mb-16" data-id="element-2526" data-mp="11k3653o8gfhk">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2527" data-mp="15jas8sd4e3q0">
              Voor wie bouwen wij?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2528" data-mp="1ak882yanqloc">
              Wij hebben ervaring in diverse sectoren.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4" data-id="element-2529" data-mp="2lxaptwohtha3">
            <div className="bg-white px-6 py-4 rounded-xl shadow-soft flex items-center gap-3" data-id="element-2530" data-mp="2lzn6m6iilllk">
              <BriefcaseIcon className="w-5 h-5 text-accent" data-id="element-2531" data-mp="2w3lgvcnfzc4s" />
              <span className="font-medium text-navy-900" data-id="element-2532" data-mp="2r3z22yrytntv">
                Zakelijke dienstverlening
              </span>
            </div>
            <div className="bg-white px-6 py-4 rounded-xl shadow-soft flex items-center gap-3" data-id="element-2533" data-mp="2m9l5it1khanm">
              <CoffeeIcon className="w-5 h-5 text-accent" data-id="element-2534" data-mp="2i8je2ydw62w7" />
              <span className="font-medium text-navy-900" data-id="element-2535" data-mp="2dc2g7cgw4a5x">Horeca</span>
            </div>
            <div className="bg-white px-6 py-4 rounded-xl shadow-soft flex items-center gap-3" data-id="element-2536" data-mp="28b4xmyryxe3w">
              <WrenchIcon className="w-5 h-5 text-accent" data-id="element-2537" data-mp="23e4ryoz16ddb" />
              <span className="font-medium text-navy-900" data-id="element-2538" data-mp="1zbhvubvbu6ab">
                Bouw & installatie
              </span>
            </div>
            <div className="bg-white px-6 py-4 rounded-xl shadow-soft flex items-center gap-3" data-id="element-2539" data-mp="1m05vu47qaai">
              <ShoppingBagIcon className="w-5 h-5 text-accent" data-id="element-2540" data-mp="3tp9d9xjwdugb" />
              <span className="font-medium text-navy-900" data-id="element-2541" data-mp="3tnog00677xer">Retail</span>
            </div>
            <div className="bg-white px-6 py-4 rounded-xl shadow-soft flex items-center gap-3" data-id="element-2542" data-mp="1r0rb8bdck4mn">
              <HeartPulseIcon className="w-5 h-5 text-accent" data-id="element-2543" data-mp="1vvng4c3ommh6" />
              <span className="font-medium text-navy-900" data-id="element-2544" data-mp="1i3gysmosm9g5">Zorg</span>
            </div>
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-white border-b border-navy-100" data-id="element-2545" data-mp="29tlh8fszsmeq">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2546" data-mp="29r8y3zbi0603">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-2547" data-mp="2erwrgrn78yxh">
            Ontdek meer:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-2548" data-mp="20sdv0w3r3c10">
            <a href="#/wordpress-websites" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2549" data-mp="25qp3b2eedeh4">
              WordPress website laten bouwen
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2550" data-mp="udwfu3sn3c6v">•</span>
            <a href="#/kosten-website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2551" data-mp="luje4ww4m8bu">
              Wat kost een website?
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2552" data-mp="vro0awpz23sn">•</span>
            <a href="#/webdesign-alkmaar" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2553" data-mp="qvyysnue6ctp">
              Webdesigner in Alkmaar
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2554" data-mp="3ud7a0oum6efg">•</span>
            <a href="#/hosting-onderhoud" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2555" data-mp="cvxu0xb0al8y">
              Hosting & technisch beheer
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-surface-muted" data-id="element-2556" data-mp="3bjv3vcp6qya6">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2557" data-mp="3bj22yscwr2zy">
          <div className="text-center mb-16" data-id="element-2558" data-mp="2q34m1uzm8edc">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2559" data-mp="2v0eku18wa2du">
              Veelgestelde vragen
            </h2>
          </div>

          <div className="space-y-4" data-id="element-2560" data-mp="2zyyaabmp5way">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-soft overflow-hidden" data-id="element-2561" data-mp="34z41xrsyvit1" data-mpi={index}>
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-2562" data-mp="38ycxn27khqr8">
                  <span className="font-bold text-navy-900" data-id="element-2563" data-mp="3isbvhp0lyodd">{faq.q}</span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-2564" data-mp="3soeyex3aar1d" /> : <ChevronDownIcon className="w-5 h-5 text-navy-400 flex-shrink-0" data-id="element-2565" data-mp="kcpq87et9kt" />}
                </button>
                {openFaq === index && <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-2566" data-mp="1l0k94p1y9s4l">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-2567" data-mp="173oxqpy87old" />
    </main>;
}